export default __webpack_public_path__ + "static/media/CocoaBean2Chocolate_04.cc002fd1.png";